import { IProduct, IProductWithState, IWorkorderLine, ProductIDType } from '@cbgms/api'
import React from 'react'

export interface OrderButtonContextProp {
  lineUUID?: string | undefined /* lineUUID will be set to workorder line that represents this part */
  placeholderLineUUID?: string | undefined /* placeholderLineUUID will be set to the parent-line, usually a genart line */
  workorderUUID: string | undefined

  // product product can be provided via product object, or passed directly
  // props passed via product object take precedence
  productId?: string
  productIdType?: ProductIDType
  unitsPerSale?: number
  recommendedQuantity?: number
  product?: IProductWithState
  onBeforeWorkorderDialog?: () => void | Promise<void>
}

export interface IExpose {
  hasBeenProvided: boolean
  isButtonLocked: boolean
  isLoading: boolean
  translationNames: 'order' | 'workorder'
  orderLine: IWorkorderLine | undefined
  productId: string
  productIdType: ProductIDType
  product?: IProductWithState
  selectedQuantity: number | undefined
  recommendedQuantity: number
  unitsPerSale: number
  forceNewLine: boolean
  onClickNewOrderLine: (exactQuantity?: number) => Promise<void>
  onClickUpdateOrderLine: (exactQuantity: number) => Promise<void>
  onClickDeleteOrderLine: (lineUUID: string) => Promise<void>
  isOpEqualOpPromotionType: boolean
  isLightsOnPromotionType: boolean
  isCommonPromotionsPromotionType: boolean
}

export type SupportTicketProduct = Pick<IProduct, 'BaseID' | 'Brand' | 'CommercialName' | 'ProductGroups' | 'RecommendedQuantity'>

export const OrderButtonContext = React.createContext<IExpose>({
  hasBeenProvided: false,
  translationNames: 'workorder',
  isButtonLocked: false,
  isLoading: false,
  orderLine: undefined,
  productId: '',
  productIdType: ProductIDType.S1,
  product: undefined,
  selectedQuantity: undefined,
  recommendedQuantity: 1,
  unitsPerSale: 1,
  forceNewLine: false,
  onClickNewOrderLine: (_?: number) => new Promise<void>(resolve => resolve()),
  onClickUpdateOrderLine: (__: number) => new Promise<void>(resolve => resolve()),
  onClickDeleteOrderLine: (_: string) => new Promise<void>(resolve => resolve()),
  isOpEqualOpPromotionType: false,
  isLightsOnPromotionType: false,
  isCommonPromotionsPromotionType: false
})

export const useOrderButtonContext = (): IExpose => {
  const v = React.useContext(OrderButtonContext)
  if (!v?.hasBeenProvided) {
    console.error('useOrderButtonContext must be used within an OrderButtonContextProvider')
  }

  return v
}

export const { Consumer: OrderButtonContextConsumer } = OrderButtonContext
